import { render, staticRenderFns } from "./app-widget-list.vue?vue&type=template&id=0fd7a9cb&functional=true&"
import script from "./app-widget-list.vue?vue&type=script&lang=js&"
export * from "./app-widget-list.vue?vue&type=script&lang=js&"
import style0 from "./app-widget-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports